export default "__VITE_ASSET__AKdXD1ap__"